import {
  ButtonProps,
  Checkbox,
  StackProps,
  Text,
  useBoolean,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

import { TypeUtils } from '../../framework/utils/UtilityTypes';
import { useSizeContext } from '../containers/SizeProvider';

type CheckAreaProps = StackProps & {
  /**
   * 追加メッセージ
   */
  additionalArea?: React.ReactNode;
  /**
   * 注意書き
   */
  attension?: string;
  /**
   * ボタン
   */
  button: React.FunctionComponent;
  /**
   * ボタンプロパティ
   */
  buttonProps?: ButtonProps;
  /**
   * 確認メッセージ
   */
  confirmMessage: string;
  doneMessage?: string;
  hiddenMessage?: string;
  /**
   * ボタンイベント
   */
  onClick?: Runnable;
};

export const useCheckArea = () => {
  const [checked, { off, on, toggle }] = useBoolean();

  const CheckArea: React.FunctionComponent<CheckAreaProps> = ({
    additionalArea,
    attension,
    button: Button,
    buttonProps,
    confirmMessage,
    doneMessage,
    hidden,
    hiddenMessage,
    onClick,
    ...props
  }) => {
    const sizes = useSizeContext();

    return (
      <VStack
        backgroundColor="white"
        border="1px"
        fontSize={sizes.fontSize.listMessage}
        hidden={hidden && TypeUtils.isNilString(hiddenMessage)}
        marginTop={{ base: 'unset', md: '5 !important' }}
        padding={3}
        width="full"
        {...props}
      >
        {TypeUtils.isNilString(doneMessage) ? (
          hidden ? (
            <Text>{hiddenMessage}</Text>
          ) : (
            <>
              {additionalArea}
              <Checkbox isChecked={checked} onChange={toggle}>
                <Text fontSize={sizes.fontSize.confirmMessage}>
                  {confirmMessage}
                </Text>
              </Checkbox>
              <Button onClick={onClick} {...buttonProps} />
              <Text
                color="red"
                fontWeight="bold"
                hidden={TypeUtils.isNilString(attension)}
              >
                {attension}
              </Text>
            </>
          )
        ) : (
          <Text>{doneMessage}</Text>
        )}
      </VStack>
    );
  };

  return { CheckArea, checked, off, on, toggle };
};
